<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";

	const {
		horizontal,
		label,
		required,
		content,
		wrapperClass,
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
	} = $props();
</script>

<div class={["flex text-left gap-2", horizontal ? "flex-row items-start" : "flex-col", wrapperClass]}>
	{#if horizontal}
		{@render content()}
	{/if}
	<label {...label}>
		{@render rest.children?.()}
		{#if required}
			<span class="text-fstphlox">*</span>
		{/if}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
</div>
